import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from './router'

import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
  // solo lectura para modificar valores de estate
  state: {
    token: '',
    usuario: '', // Datos del usuario
    refreshtoken: '',
    avatar: '', // para avatar de usuario
    logo: '', // Logo de la empresa
    notifcpes: [], // notifcpes array
    snackbar: { active: false, color: "", message: "", timeout: -1, icon: "" }
  },

  // Cuatro acciones, logica para cambiar state 
  mutations: {
    setSnackbar(state, snackbar) {
      state.snackbar = snackbar;
    },
    //decodificamos payload/token datos del usuario
    setToken(state, payload) {
      state.token = payload;
      if (payload === '') {
        state.usuario = ''
      } else {
        state.usuario = decode(payload)
      }
    },
    setRefreshToken(state, refreshpayload) {
      state.refreshtoken = refreshpayload;
    },

    setAvatar(state, avatarpayload) {
      state.avatar = avatarpayload;
    },
    setLogo(state, logopayload) {
      state.logo = logopayload;
    },

    // notifcpes
    setNotifCpes(state, notifcpes) {
      state.notifcpes = notifcpes
    },
  },

  // Realizando mutaciones
  actions: {
    snackBar({ commit }, obj) {
      commit("setSnackbar", {
        active: true,
        color: obj.cl,
        message: obj.msg,
        timeout: 8000,
        icon: obj.cl == "success" ? "check_circle" : obj.cl
      });
    },

    //Guardamos token, refreshtoken, guardaravatar, autologin y salir
    guardarToken({ commit }, payload) {
      localStorage.setItem("token", payload);
      commit("setToken", payload) //ejecutamos el payload=token
    },
    guardarRefreshToken({ commit }, refreshpayload) {
      localStorage.setItem("refreshtoken", refreshpayload);
      commit("setRefreshToken", refreshpayload)
    },

    // Guardar avatar en local Storage
    guardarAvatar({ commit }, avatarpayload) {
      localStorage.setItem("avatar", avatarpayload);
      commit("setAvatar", avatarpayload)
    },
    // Guardar logo en local Storage
    guardarLogo({ commit }, logopayload) {
      localStorage.setItem("logo", logopayload);
      commit("setLogo", logopayload)
    },

    // Verificamos si tiene token y si no salimos del sistema
    autoLogin({ commit }) {
      let token = localStorage.getItem("token")
      let refreshtoken = localStorage.getItem("refreshtoken")
      let avatar = localStorage.getItem("avatar")
      let logo = localStorage.getItem("logo")
      if (token) {
        commit("setToken", token)
        commit("setRefreshToken", refreshtoken)
        commit("setAvatar", avatar)
        commit("setLogo", logo)
        this.dispatch("cargarNotifCpes")
      } else {
        commit('setToken', '');
        commit("setRefreshToken", '')
        commit('setAvatar', '');
        commit('setLogo', '');
      }
    },

    salir({ commit }) {
      commit("setToken", '')
      commit("setRefreshToken", '')
      commit("setAvatar", '')
      commit('setLogo', '');
      localStorage.removeItem("token")
      localStorage.removeItem("refreshtoken")
      localStorage.removeItem("avatar")
      localStorage.removeItem("logo")
      router.push({ name: 'login' })
    },

    cargarNotifCpes({ commit }) {
      axios
        .get("api/Movimientos/ListarNotifCpes")
        .then(response => response.data)
        .then(notifcpes => {
          //console.log("Cpe Actualizado");
          commit('setNotifCpes', notifcpes)
        })
        .catch(function (error) {
          //console.log("Cpe Erroneo");
        });
    },
    // Accion para llamar la API 
  },

  getters: {
    estaActivo: state => !!state.token,
    esAdministrador: state => state.usuario.rol == "Administrador",
    esUsuario: state => state.usuario.rol == "Usuario",
    notifcpes: state => {
      return state.notifcpes;
    },
  }
})
